import { render, staticRenderFns } from "./MixinVideo.vue?vue&type=template&id=8cb3f8da&lang=html&"
import script from "./MixinVideo.vue?vue&type=script&lang=js&"
export * from "./MixinVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports